let React            = require("react");
const {  Link  } = require('react-router-dom');

let TooltipCard         = require("./Tooltip.jsx");
let Utility             = require("../../util/Utilities.js");
let ImportModel         = require("../../util/ImportUtil.js");
let CircuitsUtil        = require("../../util/CircuitsUtil.js");
let ObservableUtil      = require("../../util/ObservableUtil.js");
let ContentServerClient = require("../../ContentServerClient.js");
let DataActionUtil      = require("../../util/DataActionUtil.js");
let AssetDetailsLink    = require("../buttons/AssetDetailsLink.jsx");
let DownloadLibrary     = require("../../controls/buttons/DownloadLibrary.jsx");

const failedImportAgeMs = 60 * 60 * 1000; //1h

class LibraryCard extends React.Component {
    constructor() {
        super();

        this.state = { 
            vendorStatus: { isAvailable: true }, 
            status: { isloading: true, edit: false}, 
            percent: 0, 
            resource: {}, 
            deleted: false
        };

        this.handleProgress = this.handleProgress.bind(this);
        this.reloadResource = this.reloadResource.bind(this);

        this.markAsDeleted = this.markAsDeleted.bind(this);
    }

    componentDidMount() {
        let {resource} = this.props;
        let {id, name} = resource;

        this.checkStatus(resource);
        let pathname = CircuitsUtil.getViewUrl("libraries", id, name);
        this.setState({ objUrl: { pathname, state: { modal: true, previousView: location.pathname }}, resource});

        // we want to reload the resource if something about it has changed (published or deleted)
        ObservableUtil.subscribeToChange("publish", id, "libraryCard", (response, isError) => this.reloadResource(id))
        ObservableUtil.subscribeToAction("delete", id, "libraryCard", (response, isError) => this.markAsDeleted(!isError))
    }

    componentDidUpdate(prevProps, prevState){
        if(this.props.resource.id !== this.state.resource.id || 
            this.props.resource.name !== this.state.resource.name){
                this.reloadResource(this.props.resource.id)
        }
    }

    componentWillUnmount() {
        ObservableUtil.unsubscribeToChange("publish", this.props.resource.id, "libraryCard");
        ObservableUtil.unsubscribeToAction("delete", this.props.resource.id, "libraryCard");
    }

    markAsDeleted(deleted){
        this.setState({deleted});
    }

    reloadResource(assetId){
        return ContentServerClient.getFile(this.props.handleError, `/${this.props.urlName}/${assetId}`)
            .then(resource => this.setState({ resource, status: {isloading: true, edit: false} }, () => this.checkStatus(resource)))
    }

    checkStatus(resource, skipVendor){
        let {id, save_points } = resource;

        if(this.props.isPublicFacing){
            this.handleStatus(resource, ImportModel.getMessage({status: "done"}, id));
            return;
        }

        let lastImport = CircuitsUtil.getLastImportVersionIndex(resource);

        // an import will result in some import version even if the import fails,
        // so we can assume no version yet means its in progress.
        let isVendor = false;
        let status = "importing";

        if (lastImport === -1) {
            // if there is no version, the get import status call fails
            this.handleStatus(resource, ImportModel.getMessage({status: "failed"}, id));
            return;
        }

        isVendor = save_points[lastImport].source.type === "vendorLibrary";
        status = save_points[lastImport].status;

        if (status === "importing" && Utility.isOlderThan(save_points[lastImport].time, failedImportAgeMs)) {
            if (lastImport === 0) {
                // If there is only one version and it's been importing for more than 24 hours, it's probably failed so we should let user delete it
                this.handleStatus(resource, ImportModel.getMessage({status: "failed"}, id));
                return;
            } else {
                // Check previous imports to find successful one
                lastImport = CircuitsUtil.getLastImportVersionIndex(resource, true);
                if (lastImport === -1) {
                    this.handleStatus(resource, ImportModel.getMessage({status: "failed"}, id));
                    return;
                } else {
                    isVendor = save_points[lastImport].source.type === "vendorLibrary";
                    status = save_points[lastImport].status;
                }
            }
        }
        
        // If we are a vendor import, get vendor import status.
        // if the vendor import status is in progress, show in progress (0 percent)
        // if failed, show failed.  
        // if finished, proceed to check normal import and set percent.
        if(isVendor && !skipVendor){
            // if importing, start po;;
            if(status === "importing") {
                ImportModel.getVendorStatus(this.props.handleError, id)
                .then(info => {
                    // when finished, handle vendor status,
                    let success = this.handleVendorStatus(resource, info);
                    
                    // if vendor status succeeded, call this function again
                    // to poll for the regular import status
                    if(success){
                        this.checkStatus(resource, true);
                    } else {
                        // if it failed, set the regular status to failed also
                        // and don't poll.
                        this.handleStatus(resource, ImportModel.getMessage({status: "failed"}, id));
                    }
                })
                return;
            } else { 
                // if not importing, set status
                this.handleVendorStatus(resource, ImportModel.getMessage({status}, id));
            }
            
        }

        if(status === "importing") {
            ImportModel.getStatus(this.props.handleError, id, this.handleProgress)
                .then(info => this.handleStatus(resource, info))
                .catch(error => this.handleStatus(resource, ImportModel.getMessage(error, id)))
        } else {
            this.handleStatus(resource, ImportModel.getMessage({status}, id));
        }
        
    }

    handleProgress({percent}){
        this.setState({percent})
    }

    handleStatus(resource, data) {
        switch (true) {
            case data.type === "done":
                this.setState({ status: { isloading: false, type: "done", edit: true } });
            break;
            case data.type === "bad" && !CircuitsUtil.hasSuccessfulEagleImport(resource):
                this.setState({ status: { isloading: false, type: "bad", edit: false, info: data.info } });
            break;
            case data.type === "bad" && CircuitsUtil.hasSuccessfulEagleImport(resource):
                this.setState({ status: { isloading: false, type: "warn", edit: true, info: "The last version upload attempt for this library failed." } });
            break;
            default:
                this.setState({ status: { isloading: false, type: "bad", edit: false, info: data.info } });
            break;
        }
    }

    handleVendorStatus(resource, data) {
        if (data.type === "done" ) {
            this.setState({ vendorStatus: { isAvailable: true, type: "done" } });
            return true;

        } else if(data.type === "failed") {
            this.setState({ vendorStatus: { isAvailable: false, type: "bad" } });
            // if vendor status failed, regular import fails too.
            return false;
        }
    }

    getTitle(name) {
        if (this.state.status.edit) {
            return <AssetDetailsLink
                Content={()=><p className="card__name__title link">{name}</p>}
                objUrl = {this.state.objUrl}
            />
        } else {
            return <p className="card__name__title">{name}</p>
        }
    }

    // TODO use view and delete button classes here
    options() {
        const { hubDeleted = false } = this.props;

        let edit = this.state.status.edit && !this.state.deleted ?
                                <Link className="button edit" to={this.state.objUrl}><p>View</p></Link>
                                : <button className="button edit gone"></button>;

        let {resource, setConfirmation, setLoading, setError} = this.props;

        return <div className="card__item card__info">
                    { edit }
 
                    { !this.state.deleted && !hubDeleted &&
                         <button className="button delete" onClick={()=>DataActionUtil.deleteAsset(this.props.handleError, resource, setConfirmation, setLoading, setError)}>
                            <svg width="17px" height="20px"> <use xlinkHref='#delete' /> </svg>
                            <span>Delete</span>
                        </button> }
                </div>
    }

    getAvatar(){
        return  <div className="card__item card__details">
                    <div className="card__details__name"> {this.props.resource.name} </div>
                    <div className="card__details__owner">By {this.props.resource.hub_name}</div>
                </div>
    }

    formatName(name){
        return name.replace(/ /g,"-").replace("/","%2F");
    }

    render() {
        let {layout, isPublicFacing = false} = this.props;
        let {summary, id, hub_name, updated_at, save_points, name} = this.state.resource;
        let isPrivate = this.state.resource.private;
        let {status, percent, deleted, resource} = this.state;

        if((resource.deleted && !this.props.isTrash) || (!resource.deleted && this.props.isTrash) ) {
            deleted = true;
        }

        let trans = (deleted)? "deleted" : "";

        return  <div className={`card ${trans}`}>
                    <div className="card__item card__name">
                        {this.getTitle(name)}
                    </div>
                    <div className="card__item card__summary" dangerouslySetInnerHTML={{
                            __html: Utility.formatDescription(summary, layout)
                        }}>
                    </div>
                    <div className="info__status">
                    {!isPublicFacing &&
                        <TooltipCard key={id} private={isPrivate} {...status} />}
                    </div>

                    <div className="card__item card__date">
                        {Utility.formatDateString(updated_at)}
                    </div>
                    <div className="card__item card__download">
                    {!deleted && ImportModel.hasVendorImport(save_points) ?
                        <DownloadLibrary hasVendorImport={true}
                                            importAvailable={this.state.vendorStatus.isAvailable}
                                            downloadOriginalUrl={ImportModel.getLibraryDownloadPath(id, true)}
                                            downloadConvertedUrl={ImportModel.getLibraryDownloadPath(id)}/>
                        : <div className={`download`}></div>
                    }
                    </div>

                    {this.state.status.isloading ?
                        <div className="card__item card__info">
                            <div className="card__item__progress">
                                <div className="card__item__progress__bar" style={{width: `${percent}%`}}> {percent}%</div>
                            </div>
                        </div>
                        : this.options()
                    }

                    {isPublicFacing && this.getAvatar(name, hub_name)}
                </div>
    }
}

module.exports = LibraryCard;
